import { Link } from 'react-router-dom';

import { SmartTableCellProps } from '@/components/ui/daisy';
import { handleUserFullName } from '@/functions/handleUserFullName';
import { StudentPerformanceSummary } from '@/models/Student';
import { ROUTES } from '@/utils/routes';

export default function StudentNameCell({
  item,
}: SmartTableCellProps<
  Pick<StudentPerformanceSummary, 'id' | 'firstName' | 'lastName'>
>) {
  return (
    <Link
      to={ROUTES.ADMIN.STUDENTS.INFO({ idIn: String(item.id) })}
      className="text-primary underline"
    >
      {handleUserFullName(item)}
    </Link>
  );
}
